const React = require('react')
const { Container } = require('reactstrap')
require('@styles/components/common/wrapper.style.css')

const Wrapper = props => {
    return <Container className='wrapper'>{props.children}</Container>
}

module.exports = {
    Wrapper
}
